import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BookingUserDefinedField, UserDefinedField, UserDefinedFieldValue } from 'src/modules/models/booking/booking';
import { Store } from 'src/modules/store';
import { StoreBookingCostCenterUDF } from 'src/modules/store/actions';
@Component({
  selector: 'opt-booking-udf-fields',
  templateUrl: './booking-udf-fields.component.html',
})
export class BookingUdfFieldsComponent implements OnInit {

  @Input() type?: string;
  @Input() placeholder: string = 'Enter value';
  @Input() options: any[] = [];
  @Input() udfId?: string;
  @Input() initialValue?: string
  @Input() required : boolean = false;

  udfForm!: FormGroup;
  filteredOptions: any[] = [];
  searchControl = new FormControl();
  constructor(
    private fb: FormBuilder,
    private store: Store<any>
  ) { }

  ngOnInit(): void {
    this.udfForm = this.fb.group({
      value: [this.initialValue],
    });
    this.filterOptions('');
    this.searchControl.valueChanges.subscribe((search: string) => {
      this.filterOptions(search);
    });
  }


  filterOptions(value: string) {
    const filterValue = value.toLowerCase();

    if (filterValue !== "") {
      this.filteredOptions = this.options
        .filter(costCenter => costCenter.name.toLowerCase().includes(filterValue))
        .sort((a, b) => {
          const aStartsWith = a.name.toLowerCase().startsWith(filterValue) ? 0 : 1;
          const bStartsWith = b.name.toLowerCase().startsWith(filterValue) ? 0 : 1;

          if (aStartsWith !== bStartsWith) {
            return aStartsWith - bStartsWith;
          }

          return a.name.localeCompare(b.name);
        });
    } else {
      this.filteredOptions = this.options.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    }
  }


  onUDFChange(): void {
    const selectedValue = this.udfForm.value.value;

    const _bookingUserDefinedField: BookingUserDefinedField = {
      id: this.udfId,
      value: selectedValue,
      userDefinedField: {
        id: this.udfId,
        type: "UserDefinedField"
      } as UserDefinedField,
      userDefinedFieldValue: null,
      type :"BookingUserDefinedField"
    } as BookingUserDefinedField;

    if (this.type !== 'textbox') {
      const udfValue = new UserDefinedFieldValue();
      udfValue.id = selectedValue;
      _bookingUserDefinedField.userDefinedFieldValue = [udfValue];
    }else{
      _bookingUserDefinedField.userDefinedFieldValue = undefined;
    }


    this.store.dispatch(new StoreBookingCostCenterUDF( [_bookingUserDefinedField]));
  }

}
